<template>
  <div>
    <con-tab @TwoClick="TwoClick"></con-tab>
    <!-- 服务商主页 -->
    <ServiceList-Home></ServiceList-Home>
  </div>
</template>

<script>
import ConTab from "../../components/common/ConTab";
import ServiceListHome from "./base/serviceListHome";
 export default {
  name: "serviceListHome",
  data() {
    return {};
  },
  created() {},
  methods: {
    TwoClick(item) {
      //console.log(item);
      this.ConList = item;
    },
  },
  components: {
    ConTab,
    ServiceListHome,
  },
};
</script>

<style scoped>
</style>
